import React, { InputHTMLAttributes } from "react";
import classNames from "classnames";
import { CSSTransition } from "react-transition-group";

import CheckIcon from "assets/icons/checkmark-circle.svg";

import styles from "./Input.module.css";

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  error?: string | string[];
  withServerData?: boolean;
};

const Input = ({ error, withServerData, ...props }: InputProps) => {
  const nodeRef = React.useRef(null);
  return (
    <div
      className={classNames(styles.inputWrapper, {
        [styles.withError]: error,
        [styles.withServerError]: withServerData && error,
      })}
    >
      <input {...props} className={classNames(props.className, styles.input)} />
      <div className={styles.glow}></div>
      <CheckIcon className={classNames("icon", styles.validIcon)} />
      <CSSTransition
        in={!!error}
        nodeRef={nodeRef}
        timeout={300}
        classNames={{
          enter: styles.transitionEnter,
          enterActive: styles.transitionEnterActive,
          exit: styles.transitionExit,
          exitActive: styles.transitionExitActive,
        }}
      >
        <div ref={nodeRef} className={styles.error}>
          {Array.isArray(error) ? error.join(" ") : error}
        </div>
      </CSSTransition>
    </div>
  );
};

export default Input;
